/**
 * @desc 新建
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsTariffThresholdCreateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsTariffThreshold/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
